import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { TimetableWeek } from './timetable-week.interface';
import timetableWeekService from './timetable-week.service';

export interface TimetableWeekState { }

const TimetableWeekStore: Module<TimetableWeekState, StoreState> = {
   namespaced: true,

   state: {},

   getters: {},

   mutations: {},

   actions: {
      async delete(context, timetable_week_id: number) {
         return await timetableWeekService.delete(timetable_week_id).then((response) => {
            return response;
         });
      },

      async post(context, { timetable_id, timetable_week }: { timetable_id: number; timetable_week: TimetableWeek }) {
         const body = timetable_week;
         body['timetable_id'] = timetable_id;

         return await timetableWeekService.post(body).then((response) => {
            return response;
         });
      },

      async put(context, { timetable_week }: { timetable_week: TimetableWeek }) {
         return await timetableWeekService
            .put(timetable_week.id, timetable_week)
            .then((response) => {
               context.commit(
                  'board/updateWeekInTimetable',
                  { timetable_id: response.timetable.id, timetable_week_id: response.id, updated_timetable_week: response },
                  { root: true },
               );
               return response;
            })
            .catch((error) => Promise.reject(error));
      },
   },
};

export default TimetableWeekStore;
